import React, { useState, useEffect } from 'react';

import { getCategories, Category } from '../../services/categoryService';
import { getServices } from '../../services/serviceService';
import Modal from '../../components/Modal';
import MultipleSelect from '../../components/MultipleSelect/MultipleSelect';
// import { uploadPhotoToService } from '../../services/uploadPhotoToService';
// import { registerBusinessPhoto } from '../../services/registerBusinessPhoto';
// import { setMainBusinessPhoto } from '../../services/setMainBusinessPhoto';
// import { deleteBusinessPhoto } from '../../services/deleteBusinessPhoto';
// import { deletePhotoFromService } from '../../services/deletePhotoFromService';
import { BusinessGallery } from '../../components/BusinessGallery/BusinessGallery';
import './style.css';

interface BusinessModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  initialData?: any;
  mode?: 'add' | 'edit';
}

const initialState = {
  name: '',
  city: '',
  street: '',
  building: '',
  categoryIds: [] as number[],
  services: [] as number[],
  phone: '',
  is_master_business: false,
  experience: '', // Досвід майстра
};

export const BusinessModal: React.FC<BusinessModalProps> = ({ show, onClose, onSubmit, initialData, mode = 'add' }) => {
  const [form, setForm] = useState(initialState);
  const [businessId, setBusinessId] = useState<number | null>(null);
  const [categories, setCategories] = useState<Category[]>([]);
  const [services, setServices] = useState<{ id: number; name: string; category_id?: number }[]>([]); // Оновлено тип для services
  // const [logoUrl, setLogoUrl] = useState<string | null>(null);
  // const [logoFile, setLogoFile] = useState<File | null>(null);
  const [photos, setPhotos] = useState<string[]>([]);
  const [prevInitialData, setPrevInitialData] = useState<any>(null);

  useEffect(() => {
    if (show) {
      // Prefill form if editing, but only when initialData changes (not on every photo change)
      if (mode === 'edit' && initialData && initialData !== prevInitialData) {
        console.log('BusinessModal editing with initialData:', initialData);
        console.log('BusinessModal categoryIds from initialData:', initialData.categoryIds);
        setForm({
          name: initialData.name || initialData.business_name || '',
          city: initialData.city || '',
          street: initialData.street || '',
          building: initialData.building || '',
          categoryIds: initialData.categoryIds || [initialData.categoryId] || [],
          services: initialData.services || [],
          phone: initialData.phone || initialData.business_phone || '',
          is_master_business: initialData.is_master_business || false,
          experience: initialData.experience || '',
        });
        setBusinessId(initialData.id || initialData.ID || null);
        setPhotos(initialData.photos || []);
        setPrevInitialData(initialData);
      } else if (mode !== 'edit') {
        setForm(initialState);
        setBusinessId(null);
        setPhotos([]);
        setPrevInitialData(null);
      }
      getCategories().then((categories) => {
        setCategories(categories);
      });
      const token = localStorage.getItem('auth_token');
      if (!token) return;
      getServices().then((services) => {
        const uniqueServices = Array.from(
          new Map(services.map((service) => [service.name, service])).values()
        );
        setServices(uniqueServices);
      });
    }
  }, [show, mode, initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleCategoryChange = (selected: string[]) => {
    // Find category IDs by selected names
    const selectedIds = categories
      .filter(category => selected.includes(category.name))
      .map(category => category.id);
    // Filter services to only those belonging to the selected categories
    const filteredServiceIds = services
      .filter(service => selectedIds.includes(service.category_id || 0))
      .map(service => service.id);
    // Keep only services that are still valid for the selected categories
    const updatedServices = form.services.filter(serviceId => filteredServiceIds.includes(serviceId));
    setForm({ ...form, categoryIds: selectedIds, services: updatedServices });
  };

  const handleServiceChange = (selected: string[]) => {
    // Find service IDs by selected names
    const selectedIds = services
      .filter(service => selected.includes(service.name))
      .map(service => service.id);
    setForm({ ...form, services: selectedIds });
  };

  // Filter services based on selected categories
  const filteredServices = form.categoryIds.length === 0
    ? []
    : services.filter(service => form.categoryIds.includes(service.category_id || 0));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (mode === 'edit') {
      const payload: any = { ...form, id: businessId };
      // Галерея фото керується через BusinessGallery, логотип окремо не завантажується
      onSubmit(payload);
    } else {
      onSubmit(form);
    }
  };

  return (
    <Modal isOpen={show} onClose={onClose}>
      <form onSubmit={handleSubmit} className="modal-form">
        <h2 className="modal-title">{mode === 'edit' ? 'Редагувати бізнес' : 'Додати бізнес'}</h2>
        {mode === 'edit' && businessId && (
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontWeight: 500, marginBottom: 6 }}>
              <i className="bi bi-images"></i> Галерея фото
            </label>
            <BusinessGallery
              businessId={String(businessId)}
              initialPhotos={photos}
              onChange={setPhotos}
            />
          </div>
        )}
        <label>
          Назва бізнесу <span style={{color: 'red'}}>*</span>
          <input name="name" value={form.name} onChange={handleChange} placeholder="Назва бізнесу" required className="form-input" />
        </label>
        <label>
          Категорія <span style={{color: 'red'}}>*</span>
          <MultipleSelect
            label="Оберіть категорії"
            options={categories.map((category) => ({ id: category.id, name: category.name }))}
            selectedValues={categories.filter(c => form.categoryIds.includes(c.id)).map(c => c.name)}
            onChange={handleCategoryChange}
          />
        </label>
        <label>
          Послуги <span style={{color: 'red'}}>*</span>
          <MultipleSelect
            label="Оберіть послуги"
            options={filteredServices.map((service) => ({ id: service.id, name: service.name }))}
            selectedValues={filteredServices.filter(s => form.services.includes(s.id)).map(s => s.name)}
            onChange={handleServiceChange}
          />
        </label>
        <label>
          Місто <span style={{color: 'red'}}>*</span>
          <input name="city" value={form.city} onChange={handleChange} placeholder="Місто" required className="form-input" />
        </label>
        <label>
          Вулиця <span style={{color: 'red'}}>*</span>
          <input name="street" value={form.street} onChange={handleChange} placeholder="Вулиця" required className="form-input" />
        </label>
        <label>
          Номер будинку <span style={{color: 'red'}}>*</span>
          <input name="building" value={form.building} onChange={handleChange} placeholder="Будинок" required className="form-input" />
        </label>
        <label>
          Мобільний номер <span style={{color: 'red'}}>*</span>
          <input
            name="phone"
            value={form.phone || ''}
            onChange={handleChange}
            placeholder="Мобільний номер"
            required
            className="form-input"
          />
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            name="is_master_business"
            checked={form.is_master_business}
            onChange={(e) => setForm({ ...form, is_master_business: e.target.checked })}
            style={{ cursor: 'pointer' }}
          />
          Показувати як майстра (замість бізнесу)
        </label>
        <small style={{ color: '#666', marginLeft: '28px', display: 'block', marginTop: '-8px', marginBottom: '8px' }}>
          Якщо відмічено, цей бізнес буде відображатися в каталозі майстрів
        </small>
        {form.is_master_business && (
          <label>
            Досвід роботи
            <textarea
              name="experience"
              value={form.experience}
              onChange={handleChange}
              placeholder="Опишіть ваш досвід роботи (наприклад: 5+ років роботи в сфері краси, спеціалізація на..."
              className="form-input"
              rows={3}
              style={{ resize: 'vertical' }}
            />
          </label>
        )}
        <button type="submit" className="mt-3 btn-primary" style={{ alignSelf: 'flex-end' }}>Зберегти</button>
      </form>
    </Modal>
  );
};
